function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h60v60H0z"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE32",
  d: "M50.207 13.981a61.518 61.518 0 01-19.09-10.419 1.953 1.953 0 00-2.344.088 61.315 61.315 0 01-18.98 10.331 1.785 1.785 0 00-1.222 1.696V32.83a19.297 19.297 0 008.97 16.35l11.5 7.326a1.782 1.782 0 001.917 0l11.5-7.326a19.295 19.295 0 008.97-16.35V15.677c0-.77-.492-1.453-1.22-1.696z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8FBCF",
  d: "M28.773 3.65a1.953 1.953 0 012.343-.088 61.497 61.497 0 004.813 3.501L8.595 33.847a20.244 20.244 0 01-.024-1.017V15.677c0-.77.492-1.453 1.222-1.696a61.294 61.294 0 0018.98-10.33z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M27.018 27.813l-.006-2.316c0-.788.31-1.53.876-2.09A2.985 2.985 0 0130 22.541c.798 0 1.549.308 2.112.866.564.56.875 1.302.875 2.09v2.315h2.21v-2.315c0-2.838-2.328-5.14-5.198-5.14-2.87 0-5.197 2.302-5.197 5.141v2.315h2.215zm-4.488 1.478v10.351h14.94v-10.35H22.53zm8.218 5.777v1.936h-1.495v-1.936a1.58 1.58 0 01-.851-1.4c0-.872.716-1.58 1.598-1.58a1.59 1.59 0 011.599 1.58c0 .608-.346 1.134-.851 1.4z",
  fill: "#003035",
  fillRule: "nonzero"
}));

const SvgProtectionPackage = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 60 60"
}, props), _ref);

export default SvgProtectionPackage;